import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
// import { useAuth } from './components/authContext';
import Home from './pages/Home';
import ScrollToTop from './components/ScrollToTop';
import ReactGA from 'react-ga4';
import SignUp from './pages/SignUp';
import CreateListing from './pages/CreateListing';
import MyListing from './pages/MyListing';
import SignIn from './pages/SignIn';
import Preview from './pages/Preview';
import EditListing from './pages/EditListing';
import PublicListing from './pages/PublicListing';
import BookingConfirmation from './pages/BookingConfirmation';
import MyRequests from './pages/MyRequests';
import MyRequest from './pages/MyRequest';
import TrustSafety from './pages/TrustSafety';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Support from './pages/Support';

const AppRouter = () => {

  // const { user } = useAuth();

  return (
    <Router>
      <ScrollToTop />
      <AnalyticsWrapper>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/join" element={<SignUp />} />
        <Route path="/apply" element={<Navigate to="/join" replace />} />
        <Route path="/create/listing" element={<CreateListing />} />
        <Route path="/dashboard" element={<MyListing />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="/edit/listing" element={<EditListing />} />
        <Route path="/requests" element={<MyRequests />} />
        <Route path="/request/:id" element={<MyRequest />} />
        <Route path="/booking/confirm/:token" element={<BookingConfirmation />} />
        <Route path="/trust-safety" element={<TrustSafety />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/support" element={<Support />} />

        {/* public profile by username (must be after your explicit routes) */}
        <Route path="/:username" element={<PublicListing />} />
      </Routes>
      </AnalyticsWrapper>
    </Router>
  );
};


function AnalyticsWrapper({ children }) {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return children;
}

export default AppRouter;
